'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = launch;

var _reactRouterRedux = require('react-router-redux');

var _launch = require('../../actions/launch');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function launch() {
  return function (store) {
    return function (next) {
      return function (action) {
        var rawData = action.result && action.result.rawData;

        if (action.type === _reactRouterRedux.LOCATION_CHANGE) {
          store.dispatch((0, _launch.clearLaunchRawData)());
        }

        if (rawData) {
          store.dispatch((0, _launch.setLaunchRawData)(rawData));

          if (__CLIENT__ && window.rawData && !window.__rawDataFromSSR) {
            var _window$rawData;

            (_window$rawData = window.rawData).push.apply(_window$rawData, (0, _toConsumableArray3.default)(rawData));
          }
          window.__rawDataFromSSR = false;
        }

        next(action);
      };
    };
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/store/middleware/launch.js
// module id = 2545
// module chunks = 0